module.exports = __webpack_public_path__ + "static/media/sh-ac.6126dbf7.svg";